/**
 * LimitCount 省市区选择组件
 * @author jzhu
 * @date 2020-05-28
 */

import React from 'react'
import PropTypes from 'prop-types'
import { Cascader } from 'antd'

import { component_tool, framework_tool } from '@/tool'
let {
    WizButton,
    WizSelect,
    WizTooltip,
    WizInput,
    WizIcon,
    WizSwitch,
    WizLocationSelect,
    WizRow,
    WizCol,
    WizRadio,
    WizDivider,
    WizCheckbox,
    WizInputNumber
} = component_tool;
import {
    WizComponent,
    WizImage,
    WizText,
    WizScrollView,
    WizQRcode
} from '../../../module';


class LimitCount extends WizComponent {
    constructor(props) {
        super(props)
        this.limitCycleType = props && props.value && props.value.limitCycleType || 0
        this.limitNum = props && props.value && props.value.limitNum || 0
        // this.state = {
        //     limitCycleType: 0,
        //     limitNum: 0
        // }
    }
    limitCycleTypeChange = (e) => {
        this.limitCycleType = e
        this.props.onChange({
            limitCycleType: this.props.limitType === 3 ? this.limitCycleType : null,
            limitNum: this.limitNum
        })
    }
    limitNumChange = (e) => {
        this.limitNum = e
        this.props.onChange({
            limitCycleType: this.props.limitType === 3 ? this.limitCycleType : null,
            limitNum: this.limitNum
        })
    }

    render() {
        const { limitType, limitCycleType, value } = this.props
        return <tr>

            {limitType == 3 ?
                <>
                    <td>

                        <WizSelect
                            defaultValue={value && value.limitCycleType || 0}
                            onChange={this.limitCycleTypeChange}
                        >
                            <Option value={0}>年</Option>
                            <Option value={1}>月</Option>
                            <Option value={2}>周</Option>
                            <Option value={3}>日</Option>
                        </WizSelect>
                    </td>

                    <td>限制</td>
                </>
                : null}
            <>
                <td>

                    <WizInputNumber
                        style={{ 'width': '180px' }}
                        value={value && value.limitNum || 0}
                        min={0}
                        max={9999}
                        onChange={this.limitNumChange}
                        placeholder='' />
                    次
                </td>
            </>

        </tr>

    }
}

LimitCount.defaultProps = {
}

LimitCount.propTypes = {

}


export default LimitCount